/* Additional payments "Download CSV": pure column map over row_view rows + an all-pages loader. */
import { collect_all_pages, next_offset } from '../../../util_components/csv_export/collect_pages';
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import { list_view } from './adapters';
import { LIMITS } from './params';

const raw = (r) => r.row || {};

// Amount is signed rupees (a deduction is negative), as on screen.
export const ENTRY_CSV_COLUMNS = [
  { header: 'Entry ID', key: 'uuid' },
  { header: 'Teacher', value: (r) => raw(r).teacher_name || '' },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Date / time (IST)', value: (r) => raw(r).entry_at_ist, kind: 'datetime' },
  { header: 'Pay month', key: 'month_text' },
  { header: 'Category', key: 'category_label' },
  { header: 'Type', key: 'entry_type_label' },
  { header: 'Amount', key: 'amount', kind: 'money' },
  { header: 'Status', key: 'status_label' },
  { header: 'Source', key: 'source_label' },
  { header: 'From month', key: 'source_month_text' },
  { header: 'Reference', key: 'reference_id' },
  { header: 'Related session UUID', value: (r) => raw(r).related_session_uuid || '' },
  { header: 'Note', key: 'note' },
  { header: 'Added by', value: (r) => raw(r).added_by_name || raw(r).added_by || '' },
  { header: 'Added at (IST)', value: (r) => raw(r).added_at_ist, kind: 'datetime' },
  { header: 'Removed by', value: (r) => raw(r).removed_by_name || raw(r).removed_by || '' },
  { header: 'Removed at (IST)', value: (r) => raw(r).removed_at_ist, kind: 'datetime' },
  { header: 'Remove reason', key: 'remove_reason' }
];

export const entry_csv_name = (pay_month) =>
  csv_file_name({
    page: 'additional-payments',
    table: 'entries',
    period: String(pay_month || '').slice(0, 7)
  });

// Every entry matching the applied filters and sort (offset paging at the API's max page).
export const entry_csv_loader = (fetch_list, pay_month, applied) => () =>
  collect_all_pages((offset) => {
    const at = offset || 0;
    return fetch_list({ pay_month, ...applied }, LIMITS.LIST_LIMIT_MAX, at).then((data) => {
      const v = list_view(data);
      return {
        rows: v.rows,
        next: next_offset({
          offset: at,
          page_size: LIMITS.LIST_LIMIT_MAX,
          row_count: v.rows.length,
          total_count: data && typeof data.total_count === 'number' ? data.total_count : undefined
        })
      };
    });
  });
